import { createDebugger } from '~/scripts/utils/debug.js';

const debug = createDebugger('mobile-slider-thumbs', false);

document.querySelectorAll('product-images').forEach((productImages) => {
    const mediaList = productImages.querySelector('[data-product-media-list]');
    if (!mediaList) return;

    let isProgrammaticScroll = false;
    let scrollEndTimer = null;

    const onScrollEnd = () => {
        isProgrammaticScroll = false;
    };

    // Scroll slider to image when a thumbnail is clicked on mobile
    productImages.addEventListener('theme:media:select', (e) => {
        if (window.innerWidth >= 750) return;
        if (productImages.hasAttribute('data-fader-mobile')) return;

        const slide = mediaList.querySelector(`[data-media-id="${e.detail.id}"]`);
        if (!slide) return;

        debug.log('Scrolling slider to', e.detail.id);

        // Suppress observer during programmatic scroll to prevent flicker
        isProgrammaticScroll = true;
        clearTimeout(scrollEndTimer);

        mediaList.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });

        // Use scrollend if available, fall back to timeout
        mediaList.addEventListener('scrollend', onScrollEnd, { once: true });
        scrollEndTimer = setTimeout(onScrollEnd, 600);
    });

    // Update active thumbnail as the slider is swiped by the user
    const slides = mediaList.querySelectorAll('[data-media-id]');
    const observer = new IntersectionObserver(
        (entries) => {
            if (window.innerWidth >= 750) return;
            if (productImages.hasAttribute('data-fader-mobile')) return;
            if (isProgrammaticScroll) return;

            entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                    const id = entry.target.getAttribute('data-media-id');
                    if (id) {
                        debug.log('Slide in view:', id);
                        productImages.setAttribute('data-active-media', id);
                    }
                }
            });
        },
        { root: mediaList, threshold: 0.5 }
    );

    slides.forEach((slide) => observer.observe(slide));
});
